import { render, staticRenderFns } from "./ResultPdl1.vue?vue&type=template&id=319a7dd2&scoped=true&"
import script from "./ResultPdl1.vue?vue&type=script&lang=js&"
export * from "./ResultPdl1.vue?vue&type=script&lang=js&"
import style0 from "./ResultPdl1.vue?vue&type=style&index=0&id=319a7dd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319a7dd2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VChip,VSkeletonLoader})
